let focusFrom

const handleEscape = (event) => {
    if (event.key === 'Escape') {
        closeSearchOverlay()
    }
}

const openSearchOverlay = () => {
    document.body.dataset.searchOpen = 'true'
    document.addEventListener('keyup', handleEscape)
    focusFrom = document.activeElement
    document.querySelector('.searchOverlay__input').focus()
}

const closeSearchOverlay = () => {
    delete document.body.dataset.searchOpen
    document.removeEventListener('keyup', handleEscape)

    if (focusFrom) focusFrom.focus()
}

document.querySelectorAll('[data-open-search]').forEach((element) => {
    element.addEventListener('click', openSearchOverlay)
})

document.querySelectorAll('[data-close-search]').forEach((element) => {
    element.addEventListener('click', closeSearchOverlay)
})
